import React from "react";
import {connect} from "react-redux";
import {Row, Col, Tag, Button, Modal, Tabs, Avatar, List, Card, Divider, Input, Space, Breadcrumb, message} from "antd";
import {API} from '@/api';
import {string} from '@/utils/string';
import {MessageOutlined, LikeOutlined, StarOutlined, HomeOutlined, UserOutlined} from '@ant-design/icons';
import Swiper from 'react-id-swiper';
import "./style.scss";
import 'swiper/swiper.scss'
import Title from './components/Title';
import OtherListItem from './components/OtherListItem'
import SimilarListItem from './components/SimilarListItem'
import {toBookCover, toBookRead} from '@/utils/string'
import {isUserLogin} from '@/utils/user';
import eventProxy from 'react-eventProxy'
import {setStore, getStore, removeStore} from '@/utils/storage';
import cookie from "react-cookies";
import domain from '@/utils/domain';

const {TabPane} = Tabs;
const {Meta} = Card;
const {TextArea} = Input;
const swiperparams = {
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
}

@connect(
  state => ({userInfo: state.global.userInfo}),
)
export default class Cover extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      articleId: 0,
      articleinfo: [],
      authorinfo: [],
      freechapter: [],
      vipchapter: [],
      sameBooksList: [],
      reviewList: [],
      isBookCaseFlag: false,
      isLoading: false
    }
  }

  componentDidMount() {
    this.setState({
      articleId: this.props.match.params.aid
    }, () => {
      this.loadMainData();
    })

  }

  //删除
  handleDelete = (row) => {
    const {teacherList} = this.state;
    Modal.confirm({
      title: '确认',
      okText: '确认',
      cancelText: '取消',
      content: `确认是否删除「${row.name}」`,
      onOk: () => {
        this.setState({
          teacherList: teacherList.filter((item) => row.id !== item.id)
        })
      }
    });
  }
  //响应分页
  handlePageChange = (page, pageSize) => {
    console.log(`当前页：${page}，分页大小：${pageSize}`)
  }
  //搜索
  handleSearch = (params) => {
    console.log(params);
  }

  loadMainData() {
    const {articleId} = this.state
    API.bookDetail({
      articleid: articleId
    }).then((response) => {
      const {code, data, msg, time} = response;
      if (code === 1) {
        this.setState({
          articleinfo: data.articleinfo,
          authorinfo: data.authorinfo,
          freechapter: data.chapterinfo.freechapter,
          vipchapter: data.chapterinfo.vipchapter,
          isLoading: true
        }, () => {
          this.loadSameBooksData();
          this.loadReviewList();
          this.isBookCase();
        })
      } else {
        message.error(msg);
        location.href = '/';
      }
    });
  }

  loadSameBooksData() {
    const {articleId} = this.state
    API.coverSameBooksData({
      aid: articleId
    }).then((response) => {
      const {code, data, msg, time} = response;
      if (code == 1) {
        this.setState({
          sameBooksList: data
        })
      } else {
        message.error(msg);
      }
    });
  }

  loadReviewList() {
    const {articleId} = this.state
    API.bookReviewList({
      articleid: articleId
    }).then((response) => {
      const {code, data, msg, time} = response;
      if (code == 1) {
        this.setState({
          reviewList: data.list
        })
      } else {
        message.error(msg);
      }
    });
  }

  addBookCase = (articleId, chapterId) => {
    const {isBookCaseFlag} = this.state
    if (isBookCaseFlag) {
      return;
    }
    if (!isUserLogin()) {
      eventProxy.trigger('isShowUserLoginModal', true);
      return;
    }
    API.addBookCase({
      articleid: articleId,
      chapterid: chapterId,
      token: cookie.load('token')
    }).then((response) => {
      const {code, data, msg, time} = response;
      if (code === 1) {
        if (data.collect == 1) {
          message.success(msg);
          this.setState({
            isBookCaseFlag: true
          })
        }
      } else {
        message.error(msg);
      }
    });
  }

  isBookCase() {
    const {articleId} = this.state
    if (isUserLogin()) {
      return;
    }
    API.isBookCase({
      articleid: articleId,
      token: cookie.load('token')
    }).then((response) => {
      const {code, data, msg, time} = response;
      if (code === 1) {
        if (data.is_collect == 1) {
          this.setState({
            isBookCaseFlag: true
          })
        }
      } else {
        message.error(msg);
      }
    });
  }


  render() {
    const {isLoading, articleinfo, articleId, authorinfo, freechapter, vipchapter, reviewList, sameBooksList, isBookCaseFlag} = this.state;
    const {addBookCase} = this
    const {userInfo} = this.props;
    if (!isLoading) {
      return <div></div>
    }
    return (
      <div className="g-cover bg-white">
        <Space size='small'>
          <Breadcrumb>
            <Breadcrumb.Item href="">
              <span>首页</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="">
              <span>{articleinfo.sortname}</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{articleinfo.articlename}</Breadcrumb.Item>
          </Breadcrumb>
        </Space>
        <Space size='small'>
          <Row gutter={20}>
            <Col span={18}>
              <div className="g-cover-left">
                <div className="book-info">
                  <Row gutter={16} justify="center">
                    <Col span={24}>
                      <h4 className="name margin-center text-center padded-10">{articleinfo.articlename}</h4>
                      <div className="margin-center text-center padded-10">
                        <Tag className="tag" color="volcano">{articleinfo.authorname}</Tag>
                        <Tag className="tag" color="magenta">{articleinfo.sortname}</Tag>
                        <Tag className="tag" color="red">{articleinfo.fullflag}</Tag>
                      </div>
                      <img src={articleinfo.cover} className="cover margin-center margin-t-20"
                           style={{'display': 'block'}}></img>

                      <div className="font-size-16 padded-10 intro">
                        <h4 className="text-color-black">作品简介</h4>
                        <Divider className={`line pink tiny`}/>
                        {articleinfo.intros}
                      </div>
                    </Col>
                  </Row>
                  <Row justify="center" gutter={16}>
                    <Col span={4}></Col>
                    <Col span={8}><Button className="btn" size="large" block={true}
                                          onClick={() => {
                                            addBookCase(articleId, articleinfo.readchapterid)
                                          }}>{isBookCaseFlag ? '已加入书架' : '加入书架'}</Button></Col>
                    <Col span={8}><Button className="btn" size="large" block={true} onClick={() => {
                      toBookRead(articleId, articleinfo.readchapterid)
                    }}>免费试读</Button></Col>
                    <Col span={4}></Col>
                  </Row>
                  <Row justify="center" style={{'padding': '50px 0px 30px 0px'}}>
                    <Col flex={1} className="text-center">
                      <div class="text-color-pink font-size-20">{articleinfo.size}<span
                        className="font-size-14">万</span>
                      </div>
                      <div class="font-size-14 margin-t-5">字数</div>
                    </Col>
                    <Col flex={1} className="text-center">
                      <div class="text-color-pink font-size-20">{articleinfo.postdate}</div>
                      <div class="font-size-14 margin-t-5">上架时间</div>
                    </Col>
                    <Col flex={1} className="text-center">
                      <div class="text-color-pink font-size-20">{articleinfo.lastupdate}</div>
                      <div class="font-size-14 margin-t-5">最后更新时间</div>
                    </Col>
                  </Row>
                </div>
                <div className="book-chapter">
                  <Tabs defaultActiveKey="1" size='large'>
                    <TabPane tab="作品目录" key="1">
                      <Row>
                        <Col span={24}>
                          <List
                            itemLayout="horizontal"
                            grid={{
                              column: 3,
                            }}
                            bordered={false}
                            split={false}
                            dataSource={freechapter}
                            className="book-chapter-list"
                            renderItem={(item, key) => (
                              <List.Item
                                onClick={() => {
                                  toBookRead(item.articleid, item.chapterid)
                                }}>
                                <List.Item.Meta
                                  title={<span
                                    className={`chaptername font-weight-normal`}>{string.truncate(item.chaptername, 10, '...')}</span>}
                                />
                              </List.Item>
                            )
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <List
                            itemLayout="horizontal"
                            grid={{
                              gutter: 20,
                              column: 3,
                            }}
                            bordered={false}
                            split={false}
                            dataSource={vipchapter}
                            className="book-chapter-list"
                            renderItem={(item, key) => (
                              <List.Item
                                onClick={() => {
                                  toBookRead(item.articleid, item.chapterid)
                                }}
                              >
                                <List.Item.Meta
                                  title={<span
                                    className={`chaptername font-weight-normal`}>{string.truncate(item.chaptername, 10, '...')}</span>}
                                />
                                <div className="vip padded-r-15">VIP</div>
                              </List.Item>
                            )
                            }
                          />
                        </Col>
                      </Row>
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </Col>
            <Col span={6}>
              <div className="author-info">
                <Title title="作者信息" type={0}></Title>
                <Row gutter={16} justify="center">
                  <Col span={24} className="text-center">
                    <img src={articleinfo.cover} className="author-cover margin-center"></img>
                    <h5 className="text-color-black margin-t-10">{authorinfo.authorname}</h5>
                  </Col>
                  <Col span={24} className="margin-t-20 text-color-black margin-b-20">
                    <Row justify="center">
                      <Col span={8} className="text-center">
                        <div class="grid-label font-size-12"><i className="fa fa-watch"></i><br/>作品总数</div>
                        <div class="text-color-black font-size-18">{authorinfo.bookcount}</div>
                      </Col>
                      <Col span={8} className="text-center">
                        <div class="grid-label font-size-12"><i className="fa fa-book1"></i><br/>累计字数</div>
                        <div class="text-color-black font-size-18">{authorinfo.sizesum}</div>
                      </Col>
                      <Col span={8} className="text-center">
                        <div class="grid-label font-size-12"><i className="fa fa-book2"></i><br/>创作天数</div>
                        <div class="text-color-black font-size-18">{authorinfo.regdate}</div>
                      </Col>
                    </Row>
                  </Col>
                  <Divider/>
                  <Col span={24} className="text-center">
                    <Title title="其他作品" type={0}></Title>
                    <OtherListItem data={authorinfo.booklist} start={0}/>
                  </Col>
                </Row>
              </div>
              <div className="other-book">
                <Row gutter={16} justify="center">
                  <Col span={24} className="text-center">
                    <Title title="同类作品" type={0}></Title>
                    <SimilarListItem data={sameBooksList} start={0}/>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Space>
      </div>
    )
  }
}
